import {
    FETCH_REGISTRATION,
    FETCH_REGISTRATIONS,
} from '../actions/registration';


export const initialState = {
    isFetching: true,
    data: null
};

export const registrations = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_REGISTRATIONS}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_REGISTRATIONS}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                pagination: {
                    total: action.payload.total,
                    defaultPageSize: action.payload.pageSize,
                    current: action.payload.page,
                },
                searchParams: action.meta.searchParams,
                extra: action.meta.extra,
                data: action.payload.data,
            });
        default:
            return state;
    }
}

export const registration = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_REGISTRATION}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_REGISTRATION}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                data: action.payload,
            });
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/registration.js